<template>
	<div>
		<dms-row class="colision-table">
			<dms-table v-if="tableSimilarItems" :table="tableSimilarItems" :localization-off="localizationOff" :rows-on-page="6"
				row-detail-open-on-view @viewClick="getSelectedRow" @dblclick-row="fetchTable">
				<template #sideBarContent>
					<slot name="rowInfo" />
				</template>
			</dms-table>
		</dms-row>
		<dms-row v-if="!fromKZV" class="center-container">
			<dms-button :disabled="emptySimilarItems" :label-key="fromKontaktButton" @click="fromSourceClicked" />
			<dms-button :disabled="emptySimilarItems" :label-key="fromKVZButton" @click="fromDuplicateClicked" />
		</dms-row>
		<dms-row class="center-container">
			<el-table v-loading="mergeTableLoading" :data="tableData" :cell-class-name="setColorCell" border class="merge-table" @row-click="cellClick">
				<el-table-column prop="label" :label="labelName" />
				<el-table-column prop="sourceName" :label="labelSource" />
				<el-table-column v-if="!fromKZV" prop="duplicateName" :label="labelDuplicate" />
				<el-table-column v-if="!fromKZV" prop="vysledek" :label="labelResult" class-name="result" />
			</el-table>
		</dms-row>
		<dms-row class="center-container">
			<dms-button :label-key="updateButton" :disabled="emptySimilarItems" @click="update" />
			<dms-button v-if="!fromKZV" :label-key="createButton" @click="create" />
		</dms-row>
	</div>
</template>

<script>
import { snakeToPascalCase } from '@/main/utils/stringHelper';

import { DmsBaseComponent } from './dms/common/base';

export default DmsBaseComponent.extend({
	name: 'DmsMerge',
	props: {
		localizationOff: { type: Boolean, default: false },
		updateMergeTable: { type: Boolean, default: false },
		tableSimilarItems: { type: Object, default: () => {} },
		updateButton: { type: String, default: '' },
		fromKVZButton: { type: String, default: '' },
		fromKontaktButton: { type: String, default: '' },
		createButton: { type: String, default: '' },
		duplicateColumnName: { type: String, default: '' },
		sourceColumnName: { type: String, default: '' },
		labelKeyVysledek: { type: String, default: '' },
		storeModule: { type: String, default: '' },
		tableKeysIndex: { type: Object, default: () => {} },
		fromKZV: { type: Boolean, default: false },
	},
	data() {
		return {
			tableData: [],
			mergeData: {},
			mergeTableLoading: false,
		};
	},
	computed: {
		emptySimilarItems() {
			return this.tableSimilarItems ? this.tableSimilarItems.rows.length === 0 : true;
		},
		mergeTable() {
			return this.fromKZV
				? this.$store.state.pages[this.storeModule].dependentTables.MergeVozidloValues
				: this.$store.state.pages[this.storeModule].dependentTables.Merge;
		},
		labelName() {
			return this.localizationOff ? 'CIL_COLUMN_CAPTION' : this.getLabelKey('CIL_COLUMN_CAPTION', this.LocalizePopisPoli);
		},
		labelResult() {
			return this.localizationOff ? this.labelKeyVysledek : this.getLabelKey(this.labelKeyVysledek);
		},
		labelDuplicate() {
			return this.localizationOff ? this.duplicateColumnName : this.getLabelKey(this.duplicateColumnName);
		},
		labelSource() {
			return this.localizationOff ? this.sourceColumnName : this.getLabelKey(this.sourceColumnName);
		},
		mergeTableLength() {
			return this.mergeTable.rows.length;
		},
	},
	watch: {
		mergeTableLength(newVal, oldVal) {
			if (oldVal === 0) {
				this.fetchTable();
				this.mergeTableLoading = false;
			}
		},
		updateMergeTable(newVal) {
			if (newVal) {
				this.setMergeTable();
			}
		},
	},
	async created() {
		if (!this.emptySimilarItems && this.mergeTableLength === 0) {
			this.mergeTableLoading = true;
			const FIRST_INDEX = 0;
			await this.getSelectedRow(this.tableSimilarItems.rows[FIRST_INDEX].cells);
			await this.$emit('loadDependentTable', this.tableSimilarItems.rows[FIRST_INDEX].cells[FIRST_INDEX]);
		} else {
			await this.$emit('loadDependentTable', null);
			this.mergeTableLoading = false;
		}
	},
	methods: {
		async fetchTable(cells = null) {
			const FIRST_INDEX = 0;
			if (cells) {
				await this.$emit('loadDependentTable', cells[FIRST_INDEX]);
			} else {
				this.setMergeTable();
			}
		},
		setMergeTable() {
			this.tableData = [];
			this.mergeTable.rows.forEach((row) => {
				this.tableData.push({
					label: row.cells[this.tableKeysIndex.LABEL_INDEX],
					sourceName: row.cells[this.tableKeysIndex.SOURCE_NAME_INDEX],
					duplicateName: row.cells[this.tableKeysIndex.DUPLICATE_NAME_INDEX],
					vysledek: null,
					labelName: row.cells[this.tableKeysIndex.LABEL_NAME_INDEX],
				});
			});
			if (!this.emptySimilarItems) {
				this.fromSourceClicked();
			} else {
				this.fromDuplicateClicked();
			}
		},
		getSelectedRow(cells) {
			const RECORD_ID_INDEX = 0;
			this.$emit('loadInfoDetail', cells[RECORD_ID_INDEX]);
		},
		getLabelKey(labelKey, area = this.LocalizePopisostatni) {
			return this.getText(this.label, labelKey, undefined, area);
		},
		// eslint-disable-next-line consistent-return
		setColorCell(val) {
			if (val.column.label !== this.labelName && val.column.label !== this.labelResult) {
				const label = val.column.label === this.labelDuplicate ? 'duplicateName' : 'sourceName'; // TP1-TODO: duplicateName, sourceName vyseldek jako constantu
				if (val.row[label] === val.row.vysledek) {
					return 'selected';
				}
			}
		},
		cellClick(row, column) {
			if (column.label !== this.labelName && column.label !== this.labelResult) {
				const label = column.label === this.labelDuplicate ? 'duplicateName' : 'sourceName'; // TP1-TODO: duplicateName, sourceName vyseldek jako constantu
				row.vysledek = row[label];
			}
		},
		fromSourceClicked() {
			this.tableData.forEach((el) => {
				el.vysledek = el.sourceName;
			});
		},
		fromDuplicateClicked() {
			this.tableData.forEach((el) => {
				el.vysledek = el.duplicateName;
			});
		},
		getRecord() {
			const tempRecord = {};
			this.tableData.forEach((el) => {
				if (el.vysledek) {
					const key = snakeToPascalCase(el.labelName);
					tempRecord[key] = el.vysledek;
				}
			});
			return tempRecord;
		},
		update() {
			this.$emit('updateRecord', this.getRecord());
		},
		async create() {
			this.$emit('createRecord', this.getRecord());
		},
	},
});
</script>

<style lang="scss">
	.result{
		background: rgba(218, 246, 211, 0.4);
	}
	.selected {
		background: rgba(251, 255, 154, 0.37);
	}
	.border {
		border: solid;
	}
	.row-default {
		background: none;
	}
	.merge-table {
		align-self: center;
		left: 10%;
	}
	.center-container {
		padding: 15px;
		width: 80vw;
		align-items: center;
		justify-content: center;
		display: flex;
	}
</style>
